import { useEffect, useState as useReactState } from 'react';

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { debugL } from '../custom';
const db = app.firestore();

let useState;
if (process.env.NODE_ENV === 'development' && debugL > 0) {
  useState = (initialValue, stateName) => {
    const [state, setState] = useReactState(initialValue);

    debugL > 0 && useEffect(() => {
      console.log(`-------------------- UPDATED ${stateName} ` + '-'.repeat(40 - stateName.length));
    }, [state]);
  
    return [state, setState];
  };
} else {
  useState = (initialValue, stateName) => {
    const [state, setState] = useReactState(initialValue);
    return [state, setState];
  };
}

const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function emptyStrIfNull(stringToTest) {
  return stringToTest ? stringToTest : "";
}

function validateDay(daySchedule, day) {
  const partOfDays = ["morning", "afternoon"];
  for (let part of partOfDays) {
      const start = daySchedule[part + "Start"];
      const end = daySchedule[part + "End"];

      if (start < -1 || start > 24 ) {
          throw Error(`Error in ${day} in ${part} start : the hour should be in the range [-1, 24]`);
      }

      if (end < -1 || end > 24 ) {
          throw Error(`Error in ${day} in ${part} end : the hour should be in the range [-1, 24]`);
      }

      if (start * end < 0) {
          throw Error(`Error in ${day} in ${part} : start and end should be both set (0-24) or both left empty (-1)`);
      }

      if (start >= 0 && start >= end) {
          throw Error(`Error in ${day} in ${part} : end must be greater than start`);
      }
  }

  if (daySchedule["morningEnd"] > daySchedule["afternoonStart"] && daySchedule["afternoonStart"] != -1) {
      throw Error(`Error in ${day}: morningEnd can not be greater than afternoonStart`);
  }
}

function validateReccurrentSchedule(recurrentSchedule) {
  for (let day of weekDays) {
      const daySchedule = recurrentSchedule[day];
      validateDay(daySchedule, day);
  }
}

function validateExceptionalDays(exceptionalDays) {
  console.log("validation called");
  for (let exceptionalDay of exceptionalDays) {
      validateDay(exceptionalDay, "" + exceptionalDay.day +"s");
  }
}

function validateAndProcessHolidays(holidays) {
  if (typeof(holidays) !== 'string' ) {
      throw new Error('holidays should be a string');
  }

  const fullRegex =  /^( *[0-9]{1,2} *\/ *[0-9]{1,2} *,)*( *[0-9]{1,2} *\/ *[0-9]{1,2} *)*$/g;
  if(!holidays.match(fullRegex)) {
      throw new Error('holidays string does not have the good format dd/mm separated with commas');
  }

  const regex = /[0-9]{1,2}/g
  const numbers = holidays.match(regex);

  const processedHolidays = [];

  if(numbers) {
    for (let i = 0 ; i < numbers.length ; i+=2 ) {
        const day = parseInt(numbers[i]);
        const month = parseInt(numbers[i+1]);
        processedHolidays.push({day,month});
    }
  }

  return processedHolidays;
}

// // Date to string
// function timeSlotString(d, duration) {
//   return d.toLocaleDateString() + " - De " + d.getHours() + "h à " + (d.getHours() + duration) + "h";
// }

/**
 * Formats a Date object into a "HhMM" string (e.g., "9h05", "14h30").
 * @param {Date} d The date object to format.
 * @returns {string} The formatted time string.
 */
function formatTime(d) {
  const hours = d.getHours();
  const minutes = d.getMinutes();
  
  // Pad minutes with a leading zero if they are less than 10
  const paddedMinutes = String(minutes).padStart(2, '0');
  
  return `${hours}h${paddedMinutes}`;
}

/**
 * Creates a formatted string for a time slot, including date, start time, and end time.
 * @param {Date} d The start date and time.
 * @param {number} duration The duration of the slot in hours (can be a decimal, e.g., 2.5).
 * @returns {string} The complete formatted time slot string.
 */
function timeSlotString(d, duration) {
  // Calculate the end date by adding the duration in milliseconds
  const startTimeMs = d.getTime();
  const durationMs = duration * 60 * 60 * 1000;
  const endDate = new Date(startTimeMs + durationMs);

  // Use the helper to format the start and end times
  const startTimeStr = formatTime(d);
  const endTimeStr = formatTime(endDate);

  return `${d.toLocaleDateString('fr-FR')} - De ${startTimeStr} à ${endTimeStr}`;
}

async function getRetailer(retailerId) {
  try {
    let doc = ( 
      await db.collection("retailers").doc(retailerId).get()
    );

    // console.log(doc);
    // console.log(doc.data());
    return doc.data();

  } catch (e) {
    console.log("ERROR in get items");
    console.log(e.message);
    return null;
  }
}

async function getItems(retailerId, all=false) {
  try {

    let queryDocs = ( 
      await db.collection("items")
        .where("retailerId", "==", retailerId)        
        .get()
    ).docs;

    if (!all) {
      queryDocs = queryDocs
        .filter(doc => {
          const r = doc.data();
          return !r.deleted; 
        })        
    }
    // a merchant can only be in one retailer.
    const items = queryDocs
      .map(doc => {
        const r = doc.data();
        return {
          data: r,
          id: doc.id,
          name: r.name ,
          sku: r.sku,
          quantity : r.quantity,
          lowThreshold : r.lowThreshold,
        }        
      })
      .sort(((a, b) => {
        return a.sku.localeCompare(b.sku);
      }))
    return items ? items : [];

  } catch (e) {
    console.log("ERROR in get items");
    console.log(e.message);
    return [];
  }
}

async function getLocations(retailerId, all=false) {
  try {

    let queryDocs = null;
    if(retailerId == "loberz.com") {
      queryDocs = ( 
        await db.collection("locations")
          .get()
      ).docs;
    } else {
      queryDocs = ( 
        await db.collection("locations")
          .where("retailerId", "==", retailerId)
          .get()
      ).docs;
    }

    if (!all) {
      queryDocs = queryDocs
        .filter(doc => {
          const r = doc.data();
          return !r.deleted; 
        });
    }
    // a merchant can only be in one retailer.
    const locations = queryDocs
      .map(doc => {
        const r = doc.data();
        return {
          data: r,
          id: doc.id,
          name: r.name,
          contactName: emptyStrIfNull(r.contact.firstName) + " " + emptyStrIfNull(r.contact.lastName),
          address: emptyStrIfNull(r.address.streetAddress) + ", " + r.address.zipCode + " " + r.address.city,
          phoneNumber : r.contact.phoneNumber,
          position : r.position
        }        
      })

    locations.sort(locationComparator);    

    return locations ? locations : [];

  } catch (e) {
    console.log("ERROR in get locations");
    console.log(e.message);
    return [];
  }
}

function makeCode(length) {
  var result           = '';
  // var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function handlerBy(setX, preFunc, postFunc) {
  return (event) => {
    if(preFunc){
      preFunc(event.target.value);
    }
    setX(event.target.value);
    if(postFunc) {
      postFunc(event.target.value);
    }
  }
}

function handlerOfCheckboxBy(setX) {
  return (event) => setX(event.target.checked);
}

function handlerOfMultipleSelectCheckmarksBy(setX) {
  return (event) => {
    const {
      target: { value },
    } = event;
    setX(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',').map(opt => opt.trim()) : value,
    );
  }
}

const hourOptions = [
  { label: 'Select', value: '-1' },
  { label: '06:00', value: '6' },
  { label: '06:30', value: '6.5' },
  { label: '07:00', value: '7' },
  { label: '07:30', value: '7.5' },
  { label: '08:00', value: '8' },
  { label: '08:30', value: '8.5' },
  { label: '09:00', value: '9' },
  { label: '09:30', value: '9.5' },
  { label: '10:00', value: '10' },
  { label: '10:30', value: '10.5' },
  { label: '11:00', value: '11' },
  { label: '11:30', value: '11.5' },
  { label: '12:00', value: '12' },
  { label: '12:30', value: '12.5' },
  { label: '13:00', value: '13' },
  { label: '13:30', value: '13.5' },
  { label: '14:00', value: '14' },
  { label: '14:30', value: '14.5' },
  { label: '15:00', value: '15' },
  { label: '15:30', value: '15.5' },
  { label: '16:00', value: '16' },
  { label: '16:30', value: '16.5' },
  { label: '17:00', value: '17' },
  { label: '17:30', value: '17.5' },
  { label: '18:00', value: '18' },
  { label: '18:30', value: '18.5' },
  { label: '19:00', value: '19' },
  { label: '19:30', value: '19.5' },
  { label: '20:00', value: '20' },
  { label: '20:30', value: '20.5' },
  { label: '21:00', value: '21' },
  { label: '21:30', value: '21.5' },
  { label: '22:00', value: '22' },
  { label: '22:30', value: '22.5' },
  { label: '23:00', value: '23' },
  { label: '23:30', value: '23.5' },
]

function noisyWithAgrs(f) {
  return (...args) => {
    console.log("calling with", args);
    let result = f(...args);
    // console.log("called with", args, ", returned", result);
    return result;
  };
}

function noisyWithTracked(f, tracked) {
  return (...args) => {
    console.log(tracked);
    let result = f(...args);
    // console.log("called with", args, ", returned", result);
    return result;
  };
}

function shrink(input, maxL=30) {
  if(input.length <= maxL) {
    return input;
  } else {
    return input.substr(0,maxL) + "..."
  }
}

function locationComparator(a,b) {
  if(b.position == undefined) {
    return -1;
  } else if (a.position == undefined) {
    return 1;
  } else {
    return a.position - b.position;
  }
}

/**
 * Converts a time string in 'HhM' format to a decimal number.
 * For example, "7h15" becomes 7.25.
 *
 * @param {string} hourStr The time string (e.g., "7h15", "12h30").
 * @returns {number} The time as a number (e.g., 7.25, 12.5).
 * @throws {Error} If the input string format is invalid.
 */
const hourStringToDecimal = (hourStr) => {
  const [hours, minutes] = hourStringToHoursAndMinutes(hourStr)

  return hours + minutes / 60;
};

const hourStringToHoursAndMinutes = (hourStr) => {
  // console.trace('Start of hourStringToHoursAndMinutes with' + hourStr);

  if (typeof hourStr !== 'string') {
    throw new Error("Input must be a string.");
  }

  const parts = hourStr.split('h');
  const hours = parts[0] ? parseInt(parts[0], 10) : 0;
  const minutes = parts.length > 1 && parts[1] ? parseInt(parts[1], 10) : 0;

  // Check for parsing errors (NaN) or invalid minute values
  if (isNaN(hours) || isNaN(minutes) || minutes < 0 || minutes >= 60) {
    throw new Error("Invalid format. Use 'HhM' (e.g., '7h15').");
  }

  return [hours, minutes];
};

const decimalToHoursAndMinutes = (decimalHourAsNumberOrString) => {
  const decimalHour = parseFloat(decimalHourAsNumberOrString);

  if (typeof decimalHour !== 'number' || isNaN(decimalHour)) {
    throw new Error("Input must be a valid number.");
  }
  if (decimalHour < 0) {
    throw new Error("Input number cannot be negative.");
  }

  // Get the whole number part for hours
  let hours = Math.floor(decimalHour);
  // Get the fractional part and convert to minutes, rounding to avoid precision issues
  let minutes = Math.round((decimalHour - hours) * 60);

  // Handle the edge case where rounding minutes results in 60
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  return [hours, minutes];
}


/**
 * Converts a decimal number to a time string in 'HhM' format.
 * For example, 7.25 becomes "7h15".
 *
 * @param {number} decimalHour The time as a decimal number (e.g., 7.25).
 * @returns {string} The time as a string in 'HhM' format (e.g., "7h15").
 * @throws {Error} If the input is not a valid number or is negative.
 */
const decimalToHourString = (decimalHour) => {

  const [hours, minutes] = decimalToHoursAndMinutes(decimalHour);
  
  // Pad minutes with a leading zero if needed and format the string
  const paddedMinutes = String(minutes).padStart(2, '0');
  
  return `${hours}h${paddedMinutes}`;
};

/**
 * Converts a Date object's time into a decimal representation.
 * For example, a time of 14:30 is converted to 14.5.
 *
 * @param {Date} d The Date object to convert.
 * @returns {number} The time represented as a decimal number.
 * @throws {Error} If the input is not a valid Date object.
 */
const dateToDecimalHours = (d) => {
  // Validate that the input is a valid Date
  if (!(d instanceof Date) || isNaN(d.getTime())) {
    throw new Error("Input must be a valid Date object.");
  }

  const hours = d.getHours();
  const minutes = d.getMinutes();

  // Convert minutes to a fraction of an hour and add to the hours
  const decimalTime = hours + minutes / 60;

  return decimalTime;
};

// export {userLoggedInFetch, capitalize, emptyStrIfNull};
export {hourOptions, weekDays, capitalize, emptyStrIfNull, validateReccurrentSchedule, validateAndProcessHolidays, 
  validateExceptionalDays, makeCode, timeSlotString, handlerBy, handlerOfCheckboxBy, getLocations, getItems, getRetailer, 
  noisyWithAgrs, noisyWithTracked, shrink, locationComparator, handlerOfMultipleSelectCheckmarksBy, useState, 
  hourStringToDecimal, hourStringToHoursAndMinutes, decimalToHourString, decimalToHoursAndMinutes, dateToDecimalHours};



